import { Outlet } from "react-router-dom";
export const Layout = () => {
    return (
      <main style={{ padding: '1rem 0' }}>
        <Outlet />
      </main>
    );
  };